import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Varsayılan avatar (İsteğe bağlı olarak kullanıcı fotosu ile değiştirilebilir)
import user1 from "../../../assets/images/users/avatar-1.jpg";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("Kullanıcı");

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser) {
      // Veritabanı şemanızdaki Users_NameSurname alanını kullanıyoruz
      setUsername(authUser.Users_NameSurname || "Kullanıcı");
    }
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1 fw-medium">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        
        <DropdownMenu className="dropdown-menu-end shadow-sm border-0">
          {/* Hesabım: Kullanıcıyı az önce hazırladığımız profil sayfasına yönlendirir */}
          <DropdownItem tag={Link} to="/hesabim">
            <i className="bx bx-user font-size-16 align-middle me-2 text-muted" />
            {props.t("Hesabım")}
          </DropdownItem>

          {/* Yardım Merkezi: Sidebar'daki yardım merkezi ile aynı yere gider */}
          <DropdownItem tag={Link} to="/yardim-merkezi">
            <i className="bx bx-help-circle font-size-16 align-middle me-2 text-muted" />
            {props.t("Yardım Merkezi")}
          </DropdownItem>

          <div className="dropdown-divider" />
          
          {/* Çıkış Yap */}
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="bx bx-power-off font-size-16 align-middle me-2" />
            <span>{props.t("Çıkış Yap")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);